// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator settings`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companies from 'modules/core/store/collections/companies'
import legalEntities from 'modules/core/store/collections/legalEntities'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 2 cases in this module */,
    [legalEntities, {}] /* Referenced by 2 cases in this module */,
    [policyPeriods, {}] /* Referenced by 1 cases in this module */,
  ] /* Generated file 👉 artifacts/settings-module-details.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
